var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 0.133484,
    width: 45.2549,
    height: 45.2549,
    transform: "rotate(45 32 0.133484)",
    fill: "#181818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9508 44.2119C31.5303 44.7913 32.4697 44.7913 33.0492 44.2119L42.4918 34.7692C43.0713 34.1898 43.0713 33.2503 42.4918 32.6709C41.9124 32.0914 40.9729 32.0914 40.3935 32.6709L32 41.0643L23.6065 32.6709C23.0271 32.0914 22.0876 32.0914 21.5082 32.6709C20.9287 33.2503 20.9287 34.1898 21.5082 34.7692L30.9508 44.2119ZM30.5162 21.6481V43.1627H33.4838V21.6481H30.5162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.7082d731b52f51b88422cc776e0b06c9.svg";
export { ForwardRef as ReactComponent };